module.exports = __webpack_public_path__ + "img/31.33dde621.png";